// =========================================================
// * Vue Material Dashboard - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
// * Licensed under MIT (https://github.com/creativetimofficial/vue-material-dashboard/blob/master/LICENSE.md)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import axios from "axios";
import VueRouter from "vue-router";
import Loading from "vue-loading-overlay";
import VueGtag from "vue-gtag";
import "vue-loading-overlay/dist/vue-loading.css";
import VueTheMask from "vue-the-mask";

// app setup
import App from "./App";
import store from "./store";
import routes from "./routes/routes";

// Mixins
import Tenant from "./mixins/tenant";
Vue.mixin(Tenant);

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";

import Chartist from "chartist";
import "./registerServiceWorker";

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active"
});

Vue.prototype.$http = axios.create({
  baseURL: "https://api.globalfibra.com.br",
  headers: {
    common: {
      authorization: `bearer ${store.state.auth.accessToken}`
    }
  }
});

Vue.prototype.$httpGerenari = axios.create({
  baseURL: "https://gerenari-api.hubnari.com.br/central",
  headers: {
    common: {
      authorization: `bearer ${store.state.auth.gerenariAccessToken}`
    }
  }
});

Vue.prototype.$Chartist = Chartist;
store.$http = Vue.prototype.$http;
store.$httpGerenari = Vue.prototype.$httpGerenari;

Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Notifications);
Vue.use(Loading);
Vue.use(VueTheMask);
Vue.use(
  VueGtag,
  {
    config: {
      id: "G-PQRR0PMMF4",
      params: {
        user_id: store.state.auth.userId || undefined
      }
    }
  },
  router
);

// send to login if not authenticated
router.beforeEach(async (to, from, next) => {
  if (from.name == undefined) {
    try {
      await store.dispatch("fetchTenant");
      await store.dispatch("fetchUser");
    } catch (err) {
      store.dispatch("logout");
    }
  }

  if (to.name !== "Login" && !store.state.auth.accessToken) {
    next({ name: "Login" });
  } else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  data: {
    Chartist: Chartist
  }
});
